<script lang="js">
import Marquee from "../Marquee.vue";
import { RouterLink } from 'vue-router';

export default {
  name: 'BaseNavbar',
  data() {
    return {
       announcement:
        "2026/2027 Admission is still ongoing — apply now and secure your place at First City Polytechnic!",
    }
  },
  methods: {
    closeDropdowns() {
      // Find all open dropdowns and close them
      const openDropdowns = document.querySelectorAll('.dropdown-menu.show');
      openDropdowns.forEach(dropdown => {
        // Find the associated dropdown toggle button
        const dropdownToggle = dropdown.previousElementSibling;
        if (dropdownToggle && dropdownToggle.classList.contains('dropdown-toggle')) {
          // Use Bootstrap's Dropdown instance to hide the dropdown
          const bsDropdown = this.$bootstrap.Dropdown.getInstance(dropdownToggle);
          if (bsDropdown) {
            bsDropdown.hide();
          }
        }
      });

      // Also close the main navbar collapse on mobile
      const navbarCollapse = document.getElementById('navbarSupportedContent');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        const navbarToggler = document.querySelector('.navbar-toggler');
        if (navbarToggler) {
          const bsCollapse = this.$bootstrap.Collapse.getInstance(navbarCollapse);
          if (bsCollapse) {
            bsCollapse.hide();
          }
        }
      }
    },
    handleNavigation() {
      // Close all dropdowns when navigation occurs
      this.closeDropdowns();
    }
  },
  mounted() {
  },
  computed: {},
  components: { RouterLink, Marquee },
  created: function () { }
}
</script>

<template>
  <Marquee :announcement="announcement" v-if="announcement" />
  <nav class="navbar navbar-expand-lg sticky-top navbar-transparent px-md-5">
    <div class="container-fluid">
      <RouterLink
        class="navbar-brand d-flex justify-content-start align-items-center"
        to="/"
      >
        <img
          src="@/assets/logo.png"
          alt="Logo"
          class="d-inline-block align-text-top me-2"
          width="70"
        />
        <div class="text-start fcp-text-primary">
          <h5 class="fw-bold mb-0">First City Polytechnic</h5>
          <h6 class="mb-0">Abeokuta</h6>
        </div>
      </RouterLink>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item px-md-2">
            <RouterLink
              class="nav-link fcp-nav"
              to="/"
              @click="handleNavigation"
              >Home</RouterLink
            >
          </li>
          <li class="nav-item dropdown px-md-2">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              aria-expanded="false"
            >
              Academics
            </a>
            <ul class="dropdown-menu text-centerr border-0 rounded-0 shadow-lg">
              <li>
                <a class="dropdown-item disabled" target="" href="#">
                  Calendars
                </a>
              </li>
              <li class="dropdown">
                <a
                  class="dropdown-item dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  data-bs-auto-close="outside"
                  aria-expanded="false"
                >
                  Schools
                </a>
                <ul class="dropdown-menu border-0 rounded-0 shadow-lg">
                  <li class="dropdown">
                    <a
                      class="dropdown-item dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      School of Management
                    </a>
                    <ul class="dropdown-menu border-0 rounded-0 shadow-lg">
                      <li>
                        <RouterLink
                          to="/department/business-administration-and-management"
                          class="dropdown-item"
                        >
                          Business Administration and Management
                        </RouterLink>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown">
                    <a
                      class="dropdown-item dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      School of Engineering
                    </a>
                    <ul class="dropdown-menu border-0 rounded-0 shadow-lg">
                      <li>
                        <RouterLink
                          to="/department/electrical-engineering"
                          class="dropdown-item"
                        >
                          Electrical Engineering
                        </RouterLink>
                      </li>
                      <li>
                        <RouterLink
                          to="/department/computer-engineering"
                          class="dropdown-item"
                        >
                          Computer Engineering
                        </RouterLink>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown">
                    <a
                      class="dropdown-item dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      School of Science
                    </a>
                    <ul class="dropdown-menu border-0 rounded-0 shadow-lg">
                      <li>
                        <RouterLink
                          to="/department/computer-science"
                          class="dropdown-item"
                        >
                          Computer Science
                        </RouterLink>
                      </li>
                      <li>
                        <RouterLink
                          to="/department/statistics"
                          class="dropdown-item"
                        >
                          Statistics
                        </RouterLink>
                      </li>
                    </ul>
                  </li>

                  <li class="dropdown">
                    <a
                      class="dropdown-item dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      School of Liberal Studies
                    </a>
                    <ul class="dropdown-menu border-0 rounded-0 shadow-lg">
                      <li>
                        <RouterLink
                          to="/department/mass-communications"
                          class="dropdown-item"
                        >
                          Mass Communications
                        </RouterLink>
                      </li>
                    </ul>
                  </li>

                  <li class="dropdown">
                    <a
                      class="dropdown-item dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      School of Health Sciences
                    </a>
                    <ul class="dropdown-menu border-0 rounded-0 shadow-lg">
                      <li>
                        <RouterLink
                          to="/department/science-laboratory-technology"
                          class="dropdown-item"
                        >
                          Science Laboratory Technology
                        </RouterLink>
                      </li>
                      <li>
                        <RouterLink
                          to="/department/public-health"
                          class="dropdown-item"
                        >
                          Public Health
                        </RouterLink>
                      </li>
                      <li>
                        <RouterLink
                          to="/department/health-information-management"
                          class="dropdown-item"
                        >
                          Health Information Management
                        </RouterLink>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <RouterLink
                  class="dropdown-item"
                  to="/careers"
                  @click="handleNavigation"
                >
                  Careers
                </RouterLink>
              </li>
            </ul>
          </li>
          <li class="nav-item px-md-2">
            <RouterLink
              class="nav-link fcp-nav"
              to="/about"
              @click="handleNavigation"
              >About Us</RouterLink
            >
          </li>
          <li class="nav-item dropdown px-md-2">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Admissions
            </a>
            <ul class="dropdown-menu text-centerr border-0 rounded-0 shadow-lg">
              <li>
                <RouterLink
                  class="dropdown-item"
                  to="/how-to-apply"
                  @click="handleNavigation"
                >
                  How to apply
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  class="dropdown-item"
                  :to="$urlHelper.getApplyPath()"
                  @click="handleNavigation"
                >
                  New applications
                </RouterLink>
              </li>
              <li>
                <a
                  @click="$urlHelper.goToPortal('/')"
                  class="dropdown-item"
                  style="cursor: pointer"
                >
                  Applicant Portal
                </a>
              </li>
              <li>
                <RouterLink
                  class="dropdown-item"
                  to="/funding"
                  @click="handleNavigation"
                >
                  Scholarship
                </RouterLink>
              </li>
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li>
                <a
                  class="dropdown-item"
                  target="_blank"
                  href="https://onlineapp.firstcitypoly.edu.ng/Agents"
                >
                  Agent login
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown px-md-2">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Portal
            </a>
            <ul class="dropdown-menu text-center border-0 rounded-0 shadow-lg">
              <li>
                <a
                  @click="$urlHelper.goToPortal('/')"
                  class="dropdown-item"
                  style="cursor: pointer"
                >
                  Student
                </a>
              </li>
              <li>
                <a
                  @click="$urlHelper.goToStaff('/')"
                  class="dropdown-item"
                  style="cursor: pointer"
                >
                  Staff
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item px-md-2">
            <RouterLink
              class="nav-link fcp-nav"
              to="/contact"
              @click="handleNavigation"
            >
              Contact Us
            </RouterLink>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style scoped>
nav a {
  font-weight: normal;
  color: #374c91;
}

nav a.router-link-exact-active {
  font-weight: 550;
  color: #e9b500;
}

.navbar-transparent {
  background-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  /* 50% transparency */
}

/* Default button styles */
.fcp-nav {
  color: #374c91;
  /* Default text color */
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  /* Normal text weight */
  /* line-height: 45px; */
  /* margin: 0 0 2em; */
  /* max-width: 160px; */
  position: relative;
  text-decoration: none;
  text-transform: capitalize;
  width: 100%;
  border: none;
  /* Remove default border */
  background: none;
  /* No background */
}

/* Default state with no stroke */
.fcp-nav::before,
.fcp-nav::after {
  content: "";
  position: absolute;
  border: 1px solid transparent;
  /* Invisible stroke by default */
  width: 15px;
  height: 15px;
  transition: all 1.35s linear;
}

.fcp-nav::before {
  top: 0;
  left: 0;
  border-top-width: 1px;
  border-left-width: 1px;
  border-bottom: none;
  border-right: none;
}

.fcp-nav::after {
  bottom: 0;
  right: 0;
  border-bottom-width: 1px;
  border-right-width: 1px;
  border-top: none;
  border-left: none;
}

/* Hover state: transition to full stroke and bold text */
.fcp-nav:hover {
  font-weight: 550;
  text-decoration: none;
  /* No underline */
  color: #374c91;
}

.fcp-nav:hover::before,
.fcp-nav:hover::after {
  width: 100%;
  height: 100%;
  border-color: #e9b500;
  /* Change stroke color to #e9b500 */
  border-width: 1px;
  /* Full border */
}

/* Active state: top-left and bottom-right stroke, text color #e9b500 */
.fcp-nav:active,
nav a.router-link-exact-active {
  font-weight: 550;
  color: #e9b500;
}

.fcp-nav:active::before,
nav a.router-link-exact-active::before,
.fcp-nav:active::after,
nav a.router-link-exact-active::after {
  border-color: #e9b500;
  border-width: 1px;
}

/* Reset the stroke to only top-left and bottom-right when active */
.fcp-nav:active::before,
nav a.router-link-exact-active::before,
.fcp-nav:active::after,
nav a.router-link-exact-active::after {
  width: 15px;
  height: 15px;
}

/* Transition effect */
.fcp-nav,
.fcp-nav::before,
.fcp-nav::after {
  transition: all 0.35s ease;
}
</style>
